import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetOptional } from '@pool-league/shared-util-misc';
import { Player } from '@pool-league/frontend-web-data-players';
import { ResultActionButtonsComponent } from '@pool-league/frontend-web-ui-common';
import { FixtureComponent } from '../fixture/fixture.component';

@Component({
  selector: 'lib-web-league-fixture',
  imports: [CommonModule, ResultActionButtonsComponent, FixtureComponent],
  templateUrl: './league-fixture.component.html',
  styleUrl: './league-fixture.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.result-action-buttons-parent]': 'true' },
})
export class LeagueFixtureComponent {
  readonly matchNo = input.required<number>();
  // TODO: Only the id property is used - perhaps adjust the types of these inputs to just string?
  readonly breaker = input.required<SetOptional<Player, 'bbUserName'>>();
  readonly opponent = input.required<SetOptional<Player, 'bbUserName'>>();
  readonly winner = input<string>();
  readonly played = input<number>();
  readonly result = input<'F' | number>();
  readonly editable = input<boolean>(false);

  readonly infoBottom = computed(() =>
    !this.winner()
      ? undefined
      : this.result() === 'F'
        ? 'by default'
        : `with ${this.result()} ${this.result() === 1 ? 'ball' : 'balls'} remaining`,
  );
}
